import customAxios from "../serverCall";

const getAccount = async (body) => {
  const response = await customAxios.post(
    `/admin/accounts`,
    body
  );

  return response;
};

const updateAccount = async (body) => {
  const response = await customAxios.post(
    `/admin/account/activation`,
    body
  );

  return response;
};

const updateCoinBalance = async (body) => {
  // Try with /admin/ prefix first (matches pattern of other endpoints)
  // If 404, try without /admin/ prefix: `/coins/accounts/update`
  const response = await customAxios.post(
    `/admin/coins/accounts/update`,
    body
  );

  return response;
};

const updateAccountVerification = async (body) => {
  // Try the most likely endpoint first
  try {
    const response = await customAxios.post(
      `/admin/accounts/verification`,
      body
    );
    return response;
  } catch (error) {
    // If 404, try alternative endpoint
    if (error.response?.status === 404) {
      const response = await customAxios.post(
        `/admin/account/update`,
        body
      );
      return response;
    }
    throw error;
  }
};

const AccountService = {
  getAccount,
  updateAccount,
  updateCoinBalance,
  updateAccountVerification
};

export default AccountService;
